import CurrencyFormatter from "currency-formatter";

export default function Subtitle({ name, data, bold = false, margin = false }) {
  return (
    <div className="flex items-center mt-3">
      <div
        className={`whitespace-nowrap flex items-center ${bold ? "pt-4 mb-10 font-semibold border-t" : "pt-2"}`}
        style={{ minWidth: "30em" }}
      >
        {name}
      </div>
      <div className={bold ? "flex pt-4 mb-10 font-semibold border-t" : "flex pt-2"}>
        <div className="flex justify-end pr-5" style={{ minWidth: "10em" }}>
          {margin ? data * 100 : CurrencyFormatter.format(data, { code: "USD" })}
          {margin ? "%" : ""}
        </div>
      </div>
    </div>
  );
}
